<script setup>
import { ref } from 'vue'
const drawer = ref(false)
</script>

<template>
  <v-app>
    <v-app-bar v-if="isUserLoggedIn" color="black" density="compact" elevation="0" id="navbar">
      <v-app-bar-nav-icon class="d-sm-none" @click="drawer = !drawer"></v-app-bar-nav-icon>
      <div class="d-none d-sm-flex align-center">
        <v-btn to="/" variant="text" class="text-white">Dashboard</v-btn>
        <v-btn to="/obras" variant="text" class="text-white">Obras</v-btn>
        <v-btn to="/materiais" variant="text" class="text-white">Materiais</v-btn>
        <v-btn to="/guias" variant="text" class="text-white">Guias</v-btn>
        <v-btn to="/stocks" variant="text" class="text-white">Stocks</v-btn>
        <v-btn to="/unidades" variant="text" class="text-white">Unidades</v-btn>
        <v-btn @click="Logout" variant="text" class="text-white">Logout</v-btn>
      </div>
      <v-spacer></v-spacer>
      <v-img src="@/assets/logo2.png" alt="Logotipo" max-height="90" max-width="90" cover></v-img>
    </v-app-bar>

    <v-navigation-drawer v-if="isUserLoggedIn" v-model="drawer" temporary location="left" class="d-sm-none">
      <v-list>
        <v-list-item to="/" title="Dashboard" @click="drawer = false" />
        <v-list-item to="/obras" title="Obras" @click="drawer = false" />
        <v-list-item to="/materiais" title="Materiais" @click="drawer = false" />
        <v-list-item to="/guias" title="Guias" @click="drawer = false" />
        <v-list-item to="/stocks" title="Stocks" @click="drawer = false" />
        <v-list-item to="/unidades" title="Unidades" @click="drawer = false" />
        <v-list-item @click="Logout" title="Logout"/>
      </v-list>
    </v-navigation-drawer>

    <v-main class="pt-16 pb-16" style="background-color: white">
      <router-view :key="$route.fullPath"></router-view>
      <v-snackbar location="top" v-model="snackbar.visible" :color="snackbar.color" timeout="2000">
        {{ snackbar.text }}
        <template v-slot:actions>
          <v-btn color="white" variant="text" @click="snackbar.visible = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapState(['snackbar', 'isUserLoggedIn']),
  },
  methods: {
    ...mapActions(['resetStore']),
    async Logout() {
      this.resetStore()
      this.$router.push('/login')
    },
  },
}
</script>

<style>
button {
  border-radius: 25px !important;
}

.cores-linhas tbody tr:nth-child(odd) {
  background-color: white;
}

.cores-linhas tbody tr:nth-child(even) {
  background-color: #e2e1e1;
}

.cores-linhas thead {
  background-color: #9e9e9e;
  color: white;
}

.v-list-item__append > .v-icon {
  opacity: 1 !important;
}
</style>